import { render, staticRenderFns } from "./ConfigurationEditor.vue?vue&type=template&id=81e5209c&scoped=true&"
import script from "./ConfigurationEditor.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationEditor.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigurationEditor.vue?vue&type=style&index=0&id=81e5209c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81e5209c",
  null
  
)

export default component.exports